import secureLocalStorage from "react-secure-storage";
import React from "react";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { GridCell } from "@progress/kendo-react-grid";
export default class QualitativeImpactEditComponent extends GridCell {
  handleChange = async (e) => {
    this.props.onChange({
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: e.value,
    });
    if (
      this.props.field &&
      this.props.field === this.props.dataItem.inEdit &&
      this.props.dataItem.riskRegisterId
    ) {
      let updateData = {
        ...this.props.dataItem,
        [this.props.field]: e.value,
      };
      await this.props.addQualitativeImpact(updateData);
    }
  };
  handleEditCell = () => {
    if (
      this.props.dataItem.riskRegisterId &&
      !this.props.field.endsWith("_Post") &&
      !this.props.field.endsWith("_Current")
    ) {
      this.props.onEditCell(
        this.props.dataItem,
        this.props.field,
        this.props.stateData
      );
    }
  };
  render() {
    const { dataItem, field } = this.props;
    const loginUserId = parseInt(secureLocalStorage.getItem("loginUserId"));
    const ownerId = dataItem.userId;

    const value = this.props.dataItem[this.props.field];
    const impact =
      this.props.dataItem.impactResponse &&
      this.props.dataItem.impactResponse.find(
        (item) => item.name + "_" + item.type == this.props.field
      );
    let access = false;
    let tooltipVal = "";
    if (impact) {
      access = true;
      let temp =
        impact.qualityImpactList &&
        impact.qualityImpactList.find((ql) => ql.id == value);
      if (temp) {
        tooltipVal = temp.description;
      }
    }

    if (this.props.field && this.props.field === this.props.dataItem.inEdit) {
      return (
        <td>
          {/* <NumericTextBox value={value} onChange={this.handleChange} id={this.props.field}/> */}
          <DropDownList
            style={{ width: "100px" }}
            onChange={this.handleChange.bind(this)}
            // value={value}
            data={[0,1, 2, 3, 4, 5,6,7,8].slice(0,(this.props.heatMapCount+1))}
          />
        </td>
      );
    }
    if (
      this.props.dataItem.inEdit !== this.props.field ||
      this.props.dataItem.inEdit === true
    ) {
      if (loginUserId === ownerId && access) {
        return (
          <td onClick={this.handleEditCell}>
            <span>
              {this.props.field.endsWith("_Post") ? (
                <span className="yellowCell" title={tooltipVal}>
                  &nbsp; {value ? value : "0"}
                </span>
              ) : this.props.field.endsWith("_Current") ? (
                <span className="turquoiseBlue">{value ? value : "0"}</span>
              ) : (
                <span>{value?value : "0"}</span>
              )}
            </span>
          </td>
        );
      } else {
        return this.props.dataItem.role === "Standard User" ||
          this.props.dataItem.role === "View Only" ||
          !access ? (
          <td>
            <span>
              {this.props.field.endsWith("_Post") ? (
                <span className="yellowCell" title={tooltipVal}>
                  &nbsp; {value ? value : "0"}
                </span>
              ) : this.props.field.endsWith("_Current") ? (
                <span className="turquoiseBlue">{value ? value : "0"}</span>
              ) : (
                <span>{value ? value : "0"}</span>
              )}
            </span>
          </td>
        ) : (
          <td onClick={this.handleEditCell}>
            <span>
              {this.props.field.endsWith("_Post") ? (
                <span className="yellowCell" title={tooltipVal}>
                  &nbsp; {value ? value : "0"}
                </span>
              ) : this.props.field.endsWith("_Current") ? (
                <span className="turquoiseBlue">{value ? value : "0"}</span>
              ) : (
                <span>{value ? value : "0"}</span>
              )}
            </span>
          </td>
        );
      }
    }
  }
}
